export default function SortIcon() {
  return (
    <div className="rotate-180">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.14539 4.35547L5.98039 4.84747L4.52839 8.85547H4.50439V8.90272L3.80089 10.8475L3.75439 10.9645V11.8555H5.25439V11.2225L5.55889 10.3555H7.94989L8.25439 11.2225V11.8555H9.75439V10.9645L9.70714 10.8475L9.00439 8.90197V8.85547H8.98189L7.52689 4.84747L7.36489 4.35547H6.14314H6.14539ZM16.5044 4.35547V18.3715L14.5589 16.426L13.5044 17.4805L16.7144 20.7152L17.2544 21.2305L17.7944 20.7145L21.0044 17.4805L19.9499 16.426L18.0044 18.3707V4.35547H16.5044ZM6.75439 7.09747L7.38739 8.85547H6.12139L6.75439 7.09747ZM3.75439 13.3555V14.8555H7.92664L3.96439 18.8155L3.75439 19.051V20.8555H9.75439V19.3555H5.58214L9.54364 15.3955L9.75364 15.16V13.3555H3.75439Z"
          fill="black"
        />
      </svg>
    </div>
  );
}
